module.exports = __webpack_public_path__ + "static/media/icons8-quote-left-250.4cff7849.svg";